import maddyPic from "@/public/images/artists/maddy.png";
import { Artist } from "@/types/types";

export const maddy = {
  id: "154",
  name: "Maddy",
  image: maddyPic,
  description: `Maddy's voice has an uplifting timbre that adds a sweet, polished edge to any arrangement. Her delicate tone shines in softer singing styles, effortlessly enhancing Pop and EDM tracks with a light, breezy vibe. Whether layering harmonies or delivering a smooth lead, Maddy's vocals bring warmth and charm, making her sound a natural fit for the modern music scene.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmaddy-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Unprocessed",
        "Pop",
        "Dance",
        "Indie",
        "Folk",
        "Ballads",
        "Afrobeat",
        "Ethereal",
        "Falsetto",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 57,
        high: 76,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
